import React, { useEffect, useRef, useCallback } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"
const name = JSON.parse(localStorage.getItem("User"))
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  const mmRef = useRef(null)
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      // Skip MetisMenu parent toggles (hash-based hrefs like "#examination")
      // so child links are matched correctly instead of the parent
      if (items[i].getAttribute("href")?.startsWith("#")) continue

      const itemPath = items[i].pathname

      if (
        pathName === itemPath ||
        (itemPath === "/exam-master" &&
          (pathName.startsWith("/exam-master") ||
            pathName.startsWith("/exam-create") ||
            pathName.startsWith("/exam-update"))) ||
        (itemPath === "/category-master" &&
          (pathName.startsWith("/category-master") ||
            pathName.startsWith("/view-categories"))) ||
        (itemPath === "/report" &&
          (pathName.startsWith("/report") ||
            pathName.startsWith("/mark-entries"))) ||
        (itemPath === "/student-remark" &&
          pathName.startsWith("/student-remark")) ||
        (itemPath === "/grade-card" && pathName.startsWith("/grade-card")) ||
        (itemPath === "/promotion-requests" && pathName.startsWith("/promotion-requests")) ||
        (itemPath === "/fee-payment-report" && pathName.startsWith("/fee-payment-report"))
      ) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    // Dispose previous MetisMenu instance
    mmRef.current?.dispose()

    // Clean up ALL MetisMenu-managed classes before reinitializing.
    // If mm-show/mm-active are still present, init() calls show()/hide()
    // which start CSS height transitions (mm-collapsing) and set
    // isTransitioning=true. activeMenu() then manipulates the same
    // classes synchronously, preventing transitionend from firing and
    // leaving isTransitioning stuck — which blocks all future show() calls.
    const ulEl = document.getElementById("side-menu")
    if (ulEl) {
      ulEl
        .querySelectorAll("a.active")
        .forEach(el => el.classList.remove("active"))
      ulEl
        .querySelectorAll(".mm-active")
        .forEach(el => el.classList.remove("mm-active"))
      ulEl
        .querySelectorAll(".mm-show")
        .forEach(el => el.classList.remove("mm-show"))
      ulEl.querySelectorAll(".mm-collapsing").forEach(el => {
        el.classList.remove("mm-collapsing")
        el.style.height = ""
      })
    }

    // Recreate MetisMenu — init() adds mm-collapse to submenus and
    // attaches click handlers. Since no mm-show/mm-active remain,
    // hide() is a no-op and no transitions are started.
    mmRef.current = new MetisMenu("#side-menu")
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>

            <li>
              <Link to="/post">
                <i className="bx bxs-detail"></i>
                <span>{props.t("Post")}</span>
              </Link>
            </li>
            {/* {name == "Admin" ? null : ( */}
            <li>
              <Link to="/test">
                <i className="bx bx-clipboard"></i>
                <span>{props.t("Test")}</span>
              </Link>
            </li>
            <li>
              <Link to="/attendance">
                <i className="bx bx-calendar"></i>
                <span>{props.t("Attendance")}</span>
              </Link>
            </li>
            <li>
              <Link to="/chat">
                <i className="bx bx-chat"></i>
                <span>{props.t("Chat")}</span>
              </Link>
            </li>
            <li>
              <Link to="/notes">
                <i className="bx bxs-note"></i>
                <span>{props.t("Notes")}</span>
              </Link>
            </li>
            {name == "Admin" ? (
              <li>
                <Link to="/academic-calender">
                  <i className="bx bx-calendar"></i>
                  <span>{props.t("Academic Calender")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {name == "Admin" ? (
              <li>
                <Link to="/circular">
                  <i className="bx bxs-detail"></i>
                  <span>{props.t("Circular")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {name == "Admin" ? (
              <li>
                <Link to="/academic-session">
                  <i className="bx bxs-calendar"></i>
                  <span>{props.t("Academic Session")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {name == "Admin" ? (
              <>
                <li>
                  <Link to="/timetable">
                    <i className="bx bxs-calendar"></i>
                    <span>{props.t("Timetable")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/syllabus">
                    <i className="bx bx-book-content"></i>
                    <span>{props.t("Syllabus")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/classgroup">
                    <i className="bx bx-group"></i>
                    <span>{props.t("Class Group")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/holiday">
                    <i className="bx bxs-calendar"></i>
                    <span>{props.t("Holiday")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/result">
                    <i className="bx bx-award"></i>
                    <span>{props.t("Annual Result")}</span>
                  </Link>
                </li> */}
                <li>
                  <Link to="/verify-profile">
                    <i className="bx bx-user-circle"></i>
                    <span>{props.t("Profile Pic")}</span>
                  </Link>
                </li>
                
                {/* <li>
                  <Link to="/fee-payment-report">
                    <i className="bx bx-receipt"></i>
                    <span>{props.t("Fee Payment Report")}</span>
                  </Link>
                </li> */}
                <li>
                  <a href="#examination" className="has-arrow">
                    <i className="bx bx-book-open"></i>
                    <span>{props.t("Examination")}</span>
                  </a>
                  <ul className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/view-categories">
                        <span>{props.t("Assessment-Categories")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/exam-master">
                        <span>{props.t("Exam Management")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/report">
                        <span>{props.t("Mark Entry & Report")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/student-remark">
                        <span>{props.t("Student Annual Remark")}</span>
                      </Link>
                    </li>
                    
                    <li>
                      <Link to="/grade-card">
                        <span>{props.t("Marksheet")}</span>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/promotion-requests">
                    <i className="bx bx-git-pull-request"></i>
                    <span>{props.t("Promotion")}</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to="/re-admission">
                    <i className="bx bx-user-plus"></i>
                    <span>{props.t("Re-Admission")}</span>
                  </Link>
                </li> */}
              </>
            ) : (
              ""
            )}

            {name == "Admin" ? (
              <li>
                <Link to="">
                  <span>{props.t("")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
